import {formsStore} from '../../../stores/Form/FormsStore';
import {MacroItem} from '../types';
import {
    getMacroNameById as legacyGetMacroNameById,
    getMacroIdByKey as legacyGetMacroIdByKey,
    startMacro as legacyStartMacro
} from '../../../_legacy/Macro/actions/macroActions';
import {isLegacyStore} from '../../../utils/crossApi';

export const startMacroRecording = (macroInfo: Partial<MacroItem>) => {
    formsStore.setRecordingMacro(macroInfo);
    formsStore.setIsRecording(true);
};

export const stopMacroRecording = async () => {
    formsStore.setIsRecording(false);
    //
    // In this line Need add function for send new macro to server
    //
    formsStore.removeRecordingMacro();
};

export const getMacroById = (id: string) => {
    return formsStore.macros?.find(macro => macro.id === id);
};

export const getMacroNameById = id => {
    if (isLegacyStore()) {
        return legacyGetMacroNameById(id);
    }
    return formsStore.macros?.find(macro => macro.id === id)?.title;
};

export const getMacroIdByKey = key => {
    if (isLegacyStore()) {
        return legacyGetMacroIdByKey(key);
    }
    //** TODO: implement for new API */
    return null;
};

export const startMacro = id => {
    if (isLegacyStore()) {
        legacyStartMacro(id);
    }
    //** TODO: implement for new API */
};
